// // src/Components/Hooks/useNotifications.ts

// import { useState, useEffect, useCallback } from 'react';
// import axiosInstance from '../Datas/AxiosConfig';

// interface NotificationData {
//   success: boolean;
//   unread_count: number;
//   last_checked?: string;
//   new_bids?: any[];
//   new_requests?: any[];
// }

// interface UseNotificationsReturn {
//   unreadCount: number;
//   isLoading: boolean;
//   fetchNotifications: () => Promise<void>;
//   markAsRead: () => Promise<void>;
// }

// /**
//  * Custom hook for managing user notifications
//  * 
//  * @param userType - User type: 'client' | 'clientOfGoogle' | 'clientOfFacebook' | 'craftsman' | null
//  * @returns Notification state and methods
//  * 
//  * Features:
//  * - Auto-polls every 30 seconds
//  * - Supports all user types (JWT, Google, Facebook)
//  * - Handles unread count tracking
//  * - Mark as read functionality
//  */
// export const useNotifications = (userType: string | null): UseNotificationsReturn => {
//   const [unreadCount, setUnreadCount] = useState<number>(0);
//   const [isLoading, setIsLoading] = useState<boolean>(false);

//   /**
//    * Fetch notifications from backend
//    */
//   const fetchNotifications = useCallback(async () => {
//     // ✅ Skip if no valid user type
//     if (!userType || userType === 'unknown') {
//       return;
//     }

//     setIsLoading(true);

//     try {
//       let endpoint = '';
//       const params: any = {};

//       // ✅ Get user data from localStorage
//       const userStr = localStorage.getItem('user');
//       if (!userStr) {
//         setIsLoading(false);
//         return;
//       }

//       const user = JSON.parse(userStr);

//       // ========================================
//       // Determine endpoint and params based on user type
//       // ========================================
      
//       if (
//         userType === 'client' || 
//         userType === 'clientOfGoogle' || 
//         userType === 'clientOfFacebook'
//       ) {
//         // ✅ Client/Author - check for new bids
//         endpoint = 'api/notifications/unread-bids/';
        
//         // Add OAuth params if applicable
//         if (user.google_user_id) {
//           params.google_user_id = user.google_user_id;
//         } else if (user.facebook_user_id) {
//           params.facebook_user_id = user.facebook_user_id;
//         }
//         // JWT users don't need params (auth handled by token)
        
//       } else if (userType === 'craftsman') {
//         // ✅ Craftsman - check for new job requests
//         endpoint = 'api/notifications/new-requests/';
//         // JWT auth only, no params needed
        
//       } else {
//         // Unknown user type, skip
//         setIsLoading(false);
//         return;
//       }

//       // ========================================
//       // Make API request
//       // ========================================
      
//       const { data } = await axiosInstance.get<NotificationData>(endpoint, { params });

//       if (data.success && data.unread_count !== undefined) {
//         setUnreadCount(data.unread_count);
//       } else {
//         // If API returns unexpected format, reset to 0
//         setUnreadCount(0);
//       }

//     } catch (error: any) {
//       // ✅ Silent fail - don't show error to user for notifications
//       console.error('Error fetching notifications:', error);
      
//       // If 401/403, user might be logged out - reset count
//       if (error.response?.status === 401 || error.response?.status === 403) {
//         setUnreadCount(0);
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   }, [userType]);

//   /**
//    * Mark all notifications as read
//    */
//   const markAsRead = useCallback(async () => {
//     if (!userType || userType === 'unknown') {
//       return;
//     }

//     // ✅ Optimistic update - set to 0 immediately
//     setUnreadCount(0);

//     try {
//       const userStr = localStorage.getItem('user');
//       if (!userStr) return;

//       const user = JSON.parse(userStr);
//       const payload: any = {};

//       // ========================================
//       // Determine notification type and params
//       // ========================================
      
//       if (
//         userType === 'client' || 
//         userType === 'clientOfGoogle' || 
//         userType === 'clientOfFacebook'
//       ) {
//         payload.type = 'bids';
        
//         // Add OAuth params
//         if (user.google_user_id) {
//           payload.google_user_id = user.google_user_id;
//         } else if (user.facebook_user_id) {
//           payload.facebook_user_id = user.facebook_user_id;
//         }
        
//       } else if (userType === 'craftsman') {
//         payload.type = 'requests';
//       }

//       // ========================================
//       // Mark as read on backend
//       // ========================================
      
//       await axiosInstance.post('api/notifications/mark-read/', payload);

//     } catch (error) {
//       console.error('Error marking notifications as read:', error);
//       // Don't revert optimistic update - user expects badge to disappear
//     }
//   }, [userType]);

//   // ========================================
//   // Auto-polling effect
//   // ========================================
  
//   useEffect(() => {
//     // Initial fetch
//     fetchNotifications();

//     // Poll every 30 seconds
//     const interval = setInterval(() => {
//       fetchNotifications();
//     }, 30000); // 30 seconds

//     // Cleanup on unmount
//     return () => {
//       clearInterval(interval);
//     };
//   }, [fetchNotifications]);

//   return {
//     unreadCount,
//     isLoading,
//     fetchNotifications,
//     markAsRead
//   };
// };










/////////////////
// src/Components/Hooks/useNotifications.ts

import { useState, useEffect, useCallback } from 'react';
import axiosInstance from '../Datas/AxiosConfig';

interface NotificationData {
  success: boolean;
  unread_count: number;
  last_checked?: string;
  new_bids?: any[];
  new_requests?: any[];
}

interface UseNotificationsReturn {
  unreadCount: number;
  isLoading: boolean;
  fetchNotifications: () => Promise<void>;
  markAsRead: () => Promise<void>;
}

/**
 * Custom hook for managing user notifications
 * 
 * @param userType - User type: 'client' | 'clientOfGoogle' | 'clientOfFacebook' | 'craftsman' | null
 * @returns Notification state and methods
 * 
 * Features:
 * - Auto-polls every 30 seconds
 * - Supports all user types (JWT, Google, Facebook)
 * - Handles unread count tracking
 * - Mark as read functionality
 */
export const useNotifications = (userType: string | null): UseNotificationsReturn => {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  /**
   * Fetch notifications from backend
   */
  const fetchNotifications = useCallback(async () => {
    // ✅ Skip if no valid user type
    if (!userType || userType === 'unknown') {
      return;
    }

    setIsLoading(true);

    try {
      let endpoint = '';
      const params: any = {};

      // ✅ Get user data from localStorage
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        setIsLoading(false);
        return;
      }

      const user = JSON.parse(userStr);

      // ========================================
      // Determine endpoint and params based on user type
      // ========================================
      
      if (
        userType === 'client' || 
        userType === 'clientOfGoogle' || 
        userType === 'clientOfFacebook'
      ) {
        // ✅ Client/Author - check for new bids
        endpoint = 'api/notifications/unread-bids/';
        
        // ========================================
        // Extract OAuth IDs based on user_type
        // ========================================
        
        if (userType === 'clientOfFacebook' && user.email && user.email.startsWith('fb_')) {
          // ✅ Facebook: Extract from email "fb_2674802066206732@xeloba.temp"
          const fbId = user.email.split('@')[0].replace('fb_', '');
          params.facebook_user_id = fbId;
          
        } else if (userType === 'clientOfGoogle' && user.external_Id) {
          // ✅ Google: Use external_Id (Appwrite User ID)
          params.google_user_id = user.external_Id;
          
        } else if (userType === 'client') {
          // ✅ JWT Client - no params needed (uses auth token)
          // params will be empty, backend uses request.user
        }
        
      } else if (userType === 'craftsman') {
        // ✅ Craftsman - check for new job requests
        endpoint = 'api/notifications/new-requests/';
        // JWT auth only, no params needed
        
      } else {
        // Unknown user type, skip
        setIsLoading(false);
        return;
      }

      // ========================================
      // Make API request
      // ========================================
      
      const { data } = await axiosInstance.get<NotificationData>(endpoint, { params });

      if (data.success && data.unread_count !== undefined) {
        setUnreadCount(data.unread_count);
      } else {
        // If API returns unexpected format, reset to 0
        setUnreadCount(0);
      }

    } catch (error: any) {
      // ✅ Silent fail - don't show error to user for notifications
      console.error('Error fetching notifications:', error);
      
      // If 401/403, user might be logged out - reset count
      if (error.response?.status === 401 || error.response?.status === 403) {
        setUnreadCount(0);
      }
    } finally {
      setIsLoading(false);
    }
  }, [userType]);

  /**
   * Mark all notifications as read
   */
  const markAsRead = useCallback(async () => {
    if (!userType || userType === 'unknown') {
      return;
    }

    // ✅ Optimistic update - set to 0 immediately
    setUnreadCount(0);

    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) return;

      const user = JSON.parse(userStr);
      const payload: any = {};

      // ========================================
      // Determine notification type and params
      // ========================================
      
      if (
        userType === 'client' || 
        userType === 'clientOfGoogle' || 
        userType === 'clientOfFacebook'
      ) {
        payload.type = 'bids';
        
        // ========================================
        // Extract OAuth IDs
        // ========================================
        
        if (userType === 'clientOfFacebook' && user.email && user.email.startsWith('fb_')) {
          // ✅ Facebook: Extract from email
          const fbId = user.email.split('@')[0].replace('fb_', '');
          payload.facebook_user_id = fbId;
          
        } else if (userType === 'clientOfGoogle' && user.external_Id) {
          // ✅ Google: Use external_Id
          payload.google_user_id = user.external_Id;
          
        } else if (userType === 'client') {
          // ✅ JWT Client - no extra params
        }
        
      } else if (userType === 'craftsman') {
        payload.type = 'requests';
      }

      // ========================================
      // Mark as read on backend
      // ========================================
      
      await axiosInstance.post('api/notifications/mark-read/', payload);

    } catch (error) {
      console.error('Error marking notifications as read:', error);
      // Don't revert optimistic update - user expects badge to disappear
    }
  }, [userType]);

  // ========================================
  // Auto-polling effect
  // ========================================
  
  useEffect(() => {
    // Initial fetch
    fetchNotifications();

    // Poll every 30 seconds
    const interval = setInterval(() => {
      fetchNotifications();
    }, 30000); // 30 seconds

    // Cleanup on unmount
    return () => {
      clearInterval(interval);
    };
  }, [fetchNotifications]);

  return {
    unreadCount,
    isLoading,
    fetchNotifications,
    markAsRead
  };
};